module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4n5r1r2n-c3024ebf6b11556f3ae64e00598cd64c.svg";